import axios from "axios";

export const checkIfNeedAgeVerification = () => {
    return axios.get('age-verifications/check-if-verification-required')
}

export const reinitializeSession = () => {
    return axios.post('age-verifications/reinitialize-session')
}